export default "__VITE_ASSET__ITZDTKRN__"